import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ProjectsModal.module.css";
import { fetchProjects } from "../../Helpers/ProjectsHelper";

export default function ProjectsModal() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const handleClose = () => {
    dispatch(uiActions.setProjectsModalActive(false));
  };

  useEffect(() => {
    let timeoutId;

    // Listen for parent response
    const onMessage = (event) => {
      const { data /*, origin*/ } = event;
      if (!data) return;

      if (data.type === "PROJECTS_DATA") {
        setProjects(Array.isArray(data.projects) ? data.projects : []);
        setLoading(false);
        setErr("");
      }
    };

    window.addEventListener("message", onMessage);

    // Fire request to parent
    try {
      fetchProjects({ locationSearch: location.search });
    } catch (e) {
      setErr(String(e?.message || e));
      setLoading(false);
    }


    return () => {
      window.removeEventListener("message", onMessage);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount

  return (
    <PopUpModal handleClose={handleClose}>
      <div className={styles.container}>
        <h1>Projects list</h1>

        {loading && <p className={styles.muted}>Loading…</p>}
        {err && <p className={styles.error}>{err}</p>}

        {!loading && !err && (
          projects.length ? (
            <ul className={styles.list}>
              {projects.map((p) => (
                <li key={p.id} className={styles.item}>
                  <div className={styles.itemHeader}>
                    <strong className={styles.name}>{p.name}</strong>
                    <span className={styles.date}>
                      {p.createdAt ? new Date(p.createdAt).toLocaleDateString() : "—"}
                    </span>
                  </div>
                  <div className={styles.meta}>
                    <span><b>Surfaces:</b> {p.surfaces?.join(", ") || "—"}</span>
                    <span><b>Specifier:</b> {p.specifier || "—"}</span>
                    {p.thumbnail && (
                      <img className={styles.thumb} src={p.thumbnail} alt={`${p.name} preview`} />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles.muted}>No projects found.</p>
          )
        )}
      </div>
    </PopUpModal>
  );
}

export { ProjectsModal };
